document.addEventListener('DOMContentLoaded', () => {
  const debounce = (fn, delay) => {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), delay);
    };
  };

  const toggleButtons = document.querySelectorAll('.js-rated-table-toggle');
  const dropdowns = document.querySelectorAll('.js-rated-table-dropdown');
  const icons = document.querySelectorAll('.icon-table-dropdown-toggle');

  toggleButtons.forEach((toggle) => {
    const handleClick = (e) => {
      e.stopPropagation();
      const ratingBlock = toggle.closest('.rating');
      const dropdown = ratingBlock.querySelector('.js-rated-table-dropdown');
      const icon = toggle.querySelector('.icon-table-dropdown-toggle');
      const isOpen = dropdown.classList.contains('is-open');

      dropdowns.forEach((el) => {
        if (el !== dropdown) {
          el.classList.remove('is-open');
          el.style.maxHeight = '0px';
        }
      });

      icons.forEach((el) => {
        if (el !== icon) {
          el.classList.remove('rotate');
        }
      });

      if (isOpen) {
        dropdown.classList.remove('is-open');
        dropdown.style.maxHeight = '0px';
        icon.classList.remove('rotate');
      } else {
        dropdown.classList.add('is-open');
        dropdown.style.maxHeight = dropdown.scrollHeight + 'px';
        icon.classList.add('rotate');
      }
    };

    toggle.addEventListener('click', debounce(handleClick, 200));
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.rating')) {
      dropdowns.forEach((el) => {
        el.classList.remove('is-open');
        el.style.maxHeight = '0px';
      });
      icons.forEach((el) => el.classList.remove('rotate'));
    }
  });

  const sortButtons = document.querySelectorAll('.sort-btn');
  sortButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const table = btn.closest('.campaigns-table');
      const rows = Array.from(table.querySelectorAll('.table-row'));
      const getScore = (el) => parseFloat(el.dataset.score);
      const [first, second] = rows;
      const isCurrentlyAsc =
        first && second && getScore(first) < getScore(second);
      const asc = !isCurrentlyAsc;

      const sorted = rows.sort((a, b) => {
        const aScore = getScore(a);
        const bScore = getScore(b);
        return asc ? aScore - bScore : bScore - aScore;
      });

      sorted.forEach((row) => table.appendChild(row));
    });
  });
});
